import Image from "next/image";
import Link from "next/link";

const profileHref = "/meet-your-dentist/";

export default function ServiceAuthorBio() {
  return (
    <section className="w-full bg-gray-50 py-6 sm:py-8">
      <div className="max-w-6xl mx-auto px-4 sm:px-8 md:px-12">
        <div className="p-4 sm:p-5">
          <p className="mb-3 text-lg font-bold text-gray-900">
            About Our Dentist in Astoria
          </p>
          <div className="flex items-start gap-4">
            <div
              className="relative shrink-0 overflow-hidden rounded-full border-2 border-white shadow-sm"
              style={{ width: 80, height: 80, minWidth: 80 }}
            >
              <Image
                src="/images/Photo staff member standing beneath Smile4Me office sign.webp"
                alt="Dr. Iosif Khaimov standing beneath the Smile4Me office sign"
                fill
                className="object-cover object-center"
                sizes="128px"
              />
            </div>
            <div className="min-w-0 text-left">
              <Link
                href={profileHref}
                className="text-base font-bold text-[#315d7d] hover:underline"
              >
                Dr. Iosif Khaimov
              </Link>
              <p className="mt-1 text-sm leading-5 text-gray-700">
                Dr. Iosif Khaimov is a graduate of NYU&apos;s College of
                Dentistry with over seven years of hands-on patient care
                experience across NYC dental practices. He founded Smile4Me to
                bring personalized, technology-driven dentistry to the Astoria
                community, with a focus on emergency and cosmetic dentistry,
                dental implants, Invisalign, and general care. Dr. Khaimov
                regularly attends continuing education courses and dental
                conferences to stay current on the latest techniques, so every
                oral exam reflects the most up-to-date standards of care.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
